/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Coupon,
    CouponFromJSON,
    CouponToJSON,
    CouponCreateParams,
    CouponCreateParamsFromJSON,
    CouponCreateParamsToJSON,
    CouponCreateParamsV2,
    CouponCreateParamsV2FromJSON,
    CouponCreateParamsV2ToJSON,
    CouponList,
    CouponListFromJSON,
    CouponListToJSON,
    CouponListV2,
    CouponListV2FromJSON,
    CouponListV2ToJSON,
    CouponType,
    CouponTypeFromJSON,
    CouponTypeToJSON,
    CouponUpdateParams,
    CouponUpdateParamsFromJSON,
    CouponUpdateParamsToJSON,
    CouponUpdateParamsV2,
    CouponUpdateParamsV2FromJSON,
    CouponUpdateParamsV2ToJSON,
    CouponV2,
    CouponV2FromJSON,
    CouponV2ToJSON,
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetManyOrder,
    GetManyOrderFromJSON,
    GetManyOrderToJSON,
    SuccessResponse,
    SuccessResponseFromJSON,
    SuccessResponseToJSON,
} from '../models';

export interface CreateCouponRequest {
    program_id: string;
    CouponCreateParams: CouponCreateParams;
}

export interface CreateCouponV2Request {
    program_id: string;
    CouponCreateParamsV2: CouponCreateParamsV2;
}

export interface DeleteCouponRequest {
    program_id: string;
    id: string;
}

export interface DeleteCouponV2Request {
    program_id: string;
    id: string;
}

export interface DisableCouponRequest {
    program_id: string;
    id: string;
}

export interface DisableCouponV2Request {
    program_id: string;
    id: string;
}

export interface EnableCouponRequest {
    program_id: string;
    id: string;
}

export interface EnableCouponV2Request {
    program_id: string;
    id: string;
}

export interface FindCouponsRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    is_enabled?: boolean;
    type?: Array<CouponType>;
    redeemed_lt?: Date;
    redeemed_gt?: Date;
    redeemed_lte?: Date;
    redeemed_gte?: Date;
    redeem_by_lt?: Date;
    redeem_by_gt?: Date;
    redeem_by_lte?: Date;
    redeem_by_gte?: Date;
    membership_packages?: Array<string>;
    apply_automatically?: boolean;
    created_lt?: Date;
    created_gt?: Date;
    created_lte?: Date;
    created_gte?: Date;
}

export interface FindCouponsV2Request {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    id?: Array<string>;
    exclude_id?: Array<string>;
    redeemed_lt?: Date;
    redeemed_gt?: Date;
    redeemed_lte?: Date;
    redeemed_gte?: Date;
    redeem_by_lt?: Date;
    redeem_by_gt?: Date;
    redeem_by_lte?: Date;
    redeem_by_gte?: Date;
    created_lt?: Date;
    created_gt?: Date;
    created_lte?: Date;
    created_gte?: Date;
    is_enabled?: boolean;
    type?: Array<CouponType>;
    membership_packages?: Array<string>;
    apply_automatically?: boolean;
}

export interface FindOneCouponRequest {
    program_id: string;
    id: string;
}

export interface FindOneCouponV2Request {
    program_id: string;
    id: string;
}

export interface UpdateCouponRequest {
    program_id: string;
    id: string;
    CouponUpdateParams: CouponUpdateParams;
}

export interface UpdateCouponV2Request {
    program_id: string;
    id: string;
    CouponUpdateParamsV2: CouponUpdateParamsV2;
}

/**
 * 
 */
export class CouponsApi extends runtime.BaseAPI {

    /**
     * @deprecated Create coupon
     */
    async createCouponRaw(requestParameters: CreateCouponRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Coupon>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createCoupon.');
        }

        if (requestParameters.CouponCreateParams === null || requestParameters.CouponCreateParams === undefined) {
            throw new runtime.RequiredError('CouponCreateParams','Required parameter requestParameters.CouponCreateParams was null or undefined when calling createCoupon.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/coupons`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CouponCreateParamsToJSON(requestParameters.CouponCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponFromJSON(jsonValue));
    }

    /**
     * @deprecated Create coupon
     */
    async createCoupon(requestParameters: CreateCouponRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Coupon> {
        const response = await this.createCouponRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create coupon
     */
    async createCouponV2Raw(requestParameters: CreateCouponV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<CouponV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createCouponV2.');
        }

        if (requestParameters.CouponCreateParamsV2 === null || requestParameters.CouponCreateParamsV2 === undefined) {
            throw new runtime.RequiredError('CouponCreateParamsV2','Required parameter requestParameters.CouponCreateParamsV2 was null or undefined when calling createCouponV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/coupons`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CouponCreateParamsV2ToJSON(requestParameters.CouponCreateParamsV2),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponV2FromJSON(jsonValue));
    }

    /**
     * Create coupon
     */
    async createCouponV2(requestParameters: CreateCouponV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<CouponV2> {
        const response = await this.createCouponV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Delete coupon
     */
    async deleteCouponRaw(requestParameters: DeleteCouponRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling deleteCoupon.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteCoupon.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/coupons/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * @deprecated Delete coupon
     */
    async deleteCoupon(requestParameters: DeleteCouponRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.deleteCouponRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete coupon
     */
    async deleteCouponV2Raw(requestParameters: DeleteCouponV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling deleteCouponV2.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteCouponV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/coupons/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Delete coupon
     */
    async deleteCouponV2(requestParameters: DeleteCouponV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.deleteCouponV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Disable coupon
     */
    async disableCouponRaw(requestParameters: DisableCouponRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Coupon>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling disableCoupon.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableCoupon.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/coupons/{id}/disable`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponFromJSON(jsonValue));
    }

    /**
     * @deprecated Disable coupon
     */
    async disableCoupon(requestParameters: DisableCouponRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Coupon> {
        const response = await this.disableCouponRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Disable coupon
     */
    async disableCouponV2Raw(requestParameters: DisableCouponV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<CouponV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling disableCouponV2.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableCouponV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/coupons/{id}/disable`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponV2FromJSON(jsonValue));
    }

    /**
     * Disable coupon
     */
    async disableCouponV2(requestParameters: DisableCouponV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<CouponV2> {
        const response = await this.disableCouponV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Enable coupon
     */
    async enableCouponRaw(requestParameters: EnableCouponRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Coupon>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling enableCoupon.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling enableCoupon.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/coupons/{id}/enable`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponFromJSON(jsonValue));
    }

    /**
     * @deprecated Enable coupon
     */
    async enableCoupon(requestParameters: EnableCouponRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Coupon> {
        const response = await this.enableCouponRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Enable coupon
     */
    async enableCouponV2Raw(requestParameters: EnableCouponV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<CouponV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling enableCouponV2.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling enableCouponV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/coupons/{id}/enable`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponV2FromJSON(jsonValue));
    }

    /**
     * Enable coupon
     */
    async enableCouponV2(requestParameters: EnableCouponV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<CouponV2> {
        const response = await this.enableCouponV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated List all coupons
     */
    async findCouponsRaw(requestParameters: FindCouponsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<CouponList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findCoupons.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.is_enabled !== undefined) {
            queryParameters['is_enabled'] = requestParameters.is_enabled;
        }

        if (requestParameters.type) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.redeemed_lt !== undefined) {
            queryParameters['redeemed_lt'] = (requestParameters.redeemed_lt as any).toISOString();
        }

        if (requestParameters.redeemed_gt !== undefined) {
            queryParameters['redeemed_gt'] = (requestParameters.redeemed_gt as any).toISOString();
        }

        if (requestParameters.redeemed_lte !== undefined) {
            queryParameters['redeemed_lte'] = (requestParameters.redeemed_lte as any).toISOString();
        }

        if (requestParameters.redeemed_gte !== undefined) {
            queryParameters['redeemed_gte'] = (requestParameters.redeemed_gte as any).toISOString();
        }

        if (requestParameters.redeem_by_lt !== undefined) {
            queryParameters['redeem_by_lt'] = (requestParameters.redeem_by_lt as any).toISOString();
        }

        if (requestParameters.redeem_by_gt !== undefined) {
            queryParameters['redeem_by_gt'] = (requestParameters.redeem_by_gt as any).toISOString();
        }

        if (requestParameters.redeem_by_lte !== undefined) {
            queryParameters['redeem_by_lte'] = (requestParameters.redeem_by_lte as any).toISOString();
        }

        if (requestParameters.redeem_by_gte !== undefined) {
            queryParameters['redeem_by_gte'] = (requestParameters.redeem_by_gte as any).toISOString();
        }

        if (requestParameters.membership_packages) {
            queryParameters['membership_packages'] = requestParameters.membership_packages;
        }

        if (requestParameters.apply_automatically !== undefined) {
            queryParameters['apply_automatically'] = requestParameters.apply_automatically;
        }

        if (requestParameters.created_lt !== undefined) {
            queryParameters['created_lt'] = (requestParameters.created_lt as any).toISOString();
        }

        if (requestParameters.created_gt !== undefined) {
            queryParameters['created_gt'] = (requestParameters.created_gt as any).toISOString();
        }

        if (requestParameters.created_lte !== undefined) {
            queryParameters['created_lte'] = (requestParameters.created_lte as any).toISOString();
        }

        if (requestParameters.created_gte !== undefined) {
            queryParameters['created_gte'] = (requestParameters.created_gte as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/coupons`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponListFromJSON(jsonValue));
    }

    /**
     * @deprecated List all coupons
     */
    async findCoupons(requestParameters: FindCouponsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<CouponList> {
        const response = await this.findCouponsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all coupons
     */
    async findCouponsV2Raw(requestParameters: FindCouponsV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<CouponListV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findCouponsV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.exclude_id) {
            queryParameters['exclude_id'] = requestParameters.exclude_id;
        }

        if (requestParameters.redeemed_lt !== undefined) {
            queryParameters['redeemed_lt'] = (requestParameters.redeemed_lt as any).toISOString();
        }

        if (requestParameters.redeemed_gt !== undefined) {
            queryParameters['redeemed_gt'] = (requestParameters.redeemed_gt as any).toISOString();
        }

        if (requestParameters.redeemed_lte !== undefined) {
            queryParameters['redeemed_lte'] = (requestParameters.redeemed_lte as any).toISOString();
        }

        if (requestParameters.redeemed_gte !== undefined) {
            queryParameters['redeemed_gte'] = (requestParameters.redeemed_gte as any).toISOString();
        }

        if (requestParameters.redeem_by_lt !== undefined) {
            queryParameters['redeem_by_lt'] = (requestParameters.redeem_by_lt as any).toISOString();
        }

        if (requestParameters.redeem_by_gt !== undefined) {
            queryParameters['redeem_by_gt'] = (requestParameters.redeem_by_gt as any).toISOString();
        }

        if (requestParameters.redeem_by_lte !== undefined) {
            queryParameters['redeem_by_lte'] = (requestParameters.redeem_by_lte as any).toISOString();
        }

        if (requestParameters.redeem_by_gte !== undefined) {
            queryParameters['redeem_by_gte'] = (requestParameters.redeem_by_gte as any).toISOString();
        }

        if (requestParameters.created_lt !== undefined) {
            queryParameters['created_lt'] = (requestParameters.created_lt as any).toISOString();
        }

        if (requestParameters.created_gt !== undefined) {
            queryParameters['created_gt'] = (requestParameters.created_gt as any).toISOString();
        }

        if (requestParameters.created_lte !== undefined) {
            queryParameters['created_lte'] = (requestParameters.created_lte as any).toISOString();
        }

        if (requestParameters.created_gte !== undefined) {
            queryParameters['created_gte'] = (requestParameters.created_gte as any).toISOString();
        }

        if (requestParameters.is_enabled !== undefined) {
            queryParameters['is_enabled'] = requestParameters.is_enabled;
        }

        if (requestParameters.type) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.membership_packages) {
            queryParameters['membership_packages'] = requestParameters.membership_packages;
        }

        if (requestParameters.apply_automatically !== undefined) {
            queryParameters['apply_automatically'] = requestParameters.apply_automatically;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/coupons`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponListV2FromJSON(jsonValue));
    }

    /**
     * List all coupons
     */
    async findCouponsV2(requestParameters: FindCouponsV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<CouponListV2> {
        const response = await this.findCouponsV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Find coupon by id
     */
    async findOneCouponRaw(requestParameters: FindOneCouponRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Coupon>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneCoupon.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findOneCoupon.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/coupons/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponFromJSON(jsonValue));
    }

    /**
     * @deprecated Find coupon by id
     */
    async findOneCoupon(requestParameters: FindOneCouponRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Coupon> {
        const response = await this.findOneCouponRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find coupon by id
     */
    async findOneCouponV2Raw(requestParameters: FindOneCouponV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<CouponV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneCouponV2.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findOneCouponV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/coupons/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponV2FromJSON(jsonValue));
    }

    /**
     * Find coupon by id
     */
    async findOneCouponV2(requestParameters: FindOneCouponV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<CouponV2> {
        const response = await this.findOneCouponV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Update coupon
     */
    async updateCouponRaw(requestParameters: UpdateCouponRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Coupon>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateCoupon.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateCoupon.');
        }

        if (requestParameters.CouponUpdateParams === null || requestParameters.CouponUpdateParams === undefined) {
            throw new runtime.RequiredError('CouponUpdateParams','Required parameter requestParameters.CouponUpdateParams was null or undefined when calling updateCoupon.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/coupons/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CouponUpdateParamsToJSON(requestParameters.CouponUpdateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponFromJSON(jsonValue));
    }

    /**
     * @deprecated Update coupon
     */
    async updateCoupon(requestParameters: UpdateCouponRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Coupon> {
        const response = await this.updateCouponRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update coupon
     */
    async updateCouponV2Raw(requestParameters: UpdateCouponV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<CouponV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateCouponV2.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateCouponV2.');
        }

        if (requestParameters.CouponUpdateParamsV2 === null || requestParameters.CouponUpdateParamsV2 === undefined) {
            throw new runtime.RequiredError('CouponUpdateParamsV2','Required parameter requestParameters.CouponUpdateParamsV2 was null or undefined when calling updateCouponV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/coupons/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CouponUpdateParamsV2ToJSON(requestParameters.CouponUpdateParamsV2),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponV2FromJSON(jsonValue));
    }

    /**
     * Update coupon
     */
    async updateCouponV2(requestParameters: UpdateCouponV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<CouponV2> {
        const response = await this.updateCouponV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
